import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";
import { getFunnelData, getTopDropOffStep } from "@/lib/analyticsDB";
import { stepLabel } from "@/lib/analyticsDB";
import type { AnalyticsSession } from "@/lib/analyticsDB";

const STEPS = [
  { label: "Opened", color: "#10b981" },
  { label: "Q1: Industry", color: "#34d399" },
  { label: "Q2: Size", color: "#34d399" },
  { label: "Q3: Challenges", color: "#34d399" },
  { label: "Q4: Work Mode", color: "#34d399" },
  { label: "Q5: Tools", color: "#34d399" },
  { label: "Q6: Branch", color: "#f59e0b" },
  { label: "Results", color: "#f59e0b" },
  { label: "Form", color: "#3b82f6" },
  { label: "Submitted", color: "#8b5cf6" },
];

export default function FunnelChart({ sessions }: { sessions: AnalyticsSession[] }) {
  const data = getFunnelData(sessions);
  const topDropOff = getTopDropOffStep(sessions);

  return (
    <div className="glass-card p-4 md:p-5">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-5">
        <div>
          <h3 className="text-base font-bold text-white">Advisor Funnel</h3>
          <p className="text-xs text-silver-400 mt-0.5">
            Drop-off at each stage of the Product Advisor journey
          </p>
        </div>
        {topDropOff.count > 0 && (
          <div className="px-3 py-1.5 rounded-lg bg-red-500/10 border border-red-500/20 text-xs text-red-400">
            <i className="ri-error-warning-line mr-1" />
            Top drop-off: {stepLabel(topDropOff.step)} ({topDropOff.count} users)
          </div>
        )}
      </div>

      <div className="w-full" style={{ height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 5, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#2e2e3e" vertical={false} />
            <XAxis
              dataKey="label"
              tick={{ fill: "#9898b0", fontSize: 11 }}
              axisLine={{ stroke: "#2e2e3e" }}
              tickLine={false}
            />
            <YAxis
              tick={{ fill: "#9898b0", fontSize: 11 }}
              axisLine={false}
              tickLine={false}
              width={35}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#161622",
                border: "1px solid #2e2e3e",
                borderRadius: 8,
                color: "#e2e2ea",
                fontSize: 12,
              }}
              labelStyle={{ color: "#e2e2ea", fontWeight: 600 }}
              formatter={(value: number, _name, props) => [
                `${value} users (${props.payload.percentage}%)`,
                "Count",
              ]}
            />
            <Bar dataKey="count" radius={[4, 4, 0, 0]} maxBarSize={48}>
              {data.map((entry, index) => (
                <Cell key={entry.label} fill={STEPS[index]?.color || "#10b981"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}